<template>
  <Transition>
    <div class="base-popup-container" v-show="showpopup">
      <div class="popup-helper" @click="close"></div>
      <div class="popup-background"></div>
      <div width="500px" class="popup-card">
        <div class="Rectangle-1905">
          <div class="v-actions">
            <button @click="close" type="button">
              <img src="../../assets/close_popup.svg" />
            </button>
          </div>
          <slot ></slot>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: "BasePopUp",
  props: {
    showpopup: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("popupClosed");
    },

  },
};
</script>


<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.1s ease-in-out;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.popup-helper {
  z-index: 999;
  /* Comment the following line for debugging */
  opacity: 0;
  top: 0;
  left: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgb(19, 228, 0);
}
.popup-background {
  opacity: 0.5;
  top: 0;
  left: 0;
  position: absolute;
  height: 100%;
  width: 500px;
  background: #000;
  z-index: 990;
}
.popup-card {
  z-index: 1000;
  padding: 0 50px 0 50px !important;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

.Rectangle-1905 {
  display: flex;
  position: relative;
  height: 32vh;
  flex-direction: column;
  padding: 0;
  background-color: #ffffff;
  border-radius: 12px;
}

.v-actions {
  position: absolute;
  right: 1rem;
  top: 1rem;
  color: #fff;
  z-index: 3;
}


/*Mobile Query*/
@media only screen and (max-width: 600px) {

  .popup-card {
    padding: 0 40px 0 40px !important;
  }
}
@media only screen and (max-width: 500px) {
  .popup-background {
    width: 100%;
  }
}
@media only screen and (max-width: 300px), screen and (max-height: 600px) {
  .v-actions {
    right: 0.5rem;
    top: 0.5rem;
  }
  .v-actions button img {
    width: 75%;
  }
}
</style>